import { flightClassList } from '../redux/actions';
import { getDateFromYYYYMMDDString } from '../../utils/common/utils';
import sendDataToNewrelic from '@stencil/send-data-to-new-relic';
import getDateObject from '@stencil/flights-date-utils/src/get-date-object';
import { DOMESTIC } from '@stencil/flights-constants/src/text';

export const getFromUrlObject = query => {
  try {
    const queryArr = query.split('-');
    const [
      srcFromUrl,
      destFromUrl,
      depFromUrl,
      arrFromUrl,
      adultsFromUrl,
      childrenFromUrl,
      infantsFromUrl,
      classFromUrl,
      travelTypeFromUrl
    ] = queryArr;
    const source = {
      iata: srcFromUrl
    };
    const destination = {
      iata: destFromUrl
    };
    const departure = getDateFromYYYYMMDDString(depFromUrl);
    const arrival = arrFromUrl ? getDateFromYYYYMMDDString(arrFromUrl) : null;
    const passengers = {
      adult: parseInt(adultsFromUrl),
      child: parseInt(childrenFromUrl),
      infant: parseInt(infantsFromUrl)
    };
    const flightClass = {
      value: classFromUrl,
      name: flightClassList[classFromUrl]
    };
    const travelType = travelTypeFromUrl.includes('I') ? 'international' : 'domestic';
    const journeyType = arrFromUrl === '' ? 'ow' : 'rt';
    return {
      source,
      destination,
      departure,
      arrival,
      passengers,
      flightClass,
      journeyType,
      travelType
    };
  } catch (err) {
    sendDataToNewrelic('GetFromUrlObject', `Failed with error: ${err}`);
  }
};

export const getFromUrlObjectForGroundUp = query => {
  try {
    const queryArr = query.split('-');
    const [
      srcFromUrl,
      destFromUrl,
      depFromUrl,
      arrFromUrl,
      adultsFromUrl,
      childrenFromUrl,
      infantsFromUrl,
      classFromUrl,
      fareIdentifier
    ] = queryArr;
    const source = {
      iata: srcFromUrl
    };
    const destination = {
      iata: destFromUrl
    };
    const departure = getDateFromYYYYMMDDString(depFromUrl);
    const arrival = arrFromUrl ? getDateFromYYYYMMDDString(arrFromUrl) : null;
    const passengers = {
      adult: parseInt(adultsFromUrl),
      child: parseInt(childrenFromUrl),
      infant: parseInt(infantsFromUrl)
    };
    const flightClass = {
      value: classFromUrl,
      name: flightClassList[classFromUrl]
    };
    const journeyType = arrFromUrl === '' ? 'ow' : 'rt';
    return {
      source,
      destination,
      departure,
      arrival,
      passengers,
      flightClass,
      journeyType,
      selectedFareIdentifier: fareIdentifier.replace('/', ''),
      travelType: DOMESTIC
    };
  } catch (err) {
    sendDataToNewrelic('GetFromUrlObject', `Failed with error: ${err}`);
  }
};

export const getCityCountryUrlObject = searchString => {
  try {
    const urlParams = new URLSearchParams(searchString);
    const journeyTypeFromUrl = urlParams.get('tripType') || '';
    const srcCity = urlParams.get('from') || '';
    const countryCode = urlParams.get('toCountry') || '';
    const continentCode = urlParams.get('toContinent') || '';
    const destCity = urlParams.get('to') || '';
    const yearMonth = urlParams.get('month') || '';
    const labelFrom = urlParams.get('labelFrom') || '';
    const labelTo = urlParams.get('labelTo') || '';
    const passengersString = urlParams.get('passengers') || '';
    const duration = urlParams.get('duration') || '';

    const isOneWay = journeyTypeFromUrl === 'OW' ? true : false;

    const source = { iata: srcCity, ct: labelFrom };

    let destination = {};
    if (countryCode) {
      destination = { cc: countryCode, cnty: labelTo, t: 'country' };
    } else if (continentCode) {
      destination = { coc: continentCode, con: labelTo, t: 'continent' };
    } else if (destCity) {
      destination = { iata: destCity, ct: labelTo, t: 'city' };
    }

    let isAnywhere = false;
    if (destCity == 'ANYWHERE') {
      isAnywhere = true;
    }

    let travelDate = null,
      anyTime = true;
    if (yearMonth && yearMonth !== 'ANYTIME') {
      anyTime = false;
      const year = +yearMonth.slice(0, 4);
      const month = +yearMonth.slice(4);
      const date = new Date(year, month - 1, 1);
      travelDate = getDateObject(date);
    }

    let tripDuration = 14;
    if (duration) {
      tripDuration = parseInt(duration);
    }

    const passengersArray = passengersString ? passengersString.split('-') : ['1', '0', '0', 'E'];
    const [adults, children, infants, flightClassFromUrl] = passengersArray;
    const passengers = {
      adult: parseInt(adults),
      child: parseInt(children),
      infant: parseInt(infants)
    };
    const flightClass = {
      value: flightClassFromUrl,
      name: flightClassList[flightClassFromUrl]
    };

    const travelType = 'international';
    const journeyType = journeyTypeFromUrl === 'OW' ? 'ow' : 'rt';

    return {
      source,
      destination,
      isAnywhere,
      travelDate,
      anyTime,
      tripDuration,
      passengers,
      flightClass,
      journeyType,
      travelType
    };
  } catch (err) {
    sendDataToNewrelic('GetFromUrlObject', `Failed with error: ${err}`);
  }
};
